import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildBrandCaptionLowerThirdEntity } from "@youm-front/brand/utils/factory";
import {
  ROOM_BRAND_CAPTION_LOWER_THIRD_FEATURE_KEY,
  RoomBrandCaptionLowerThirdState
} from "../reducers";

const roomBrandCaptionLowerThirdState =
  createFeatureSelector<RoomBrandCaptionLowerThirdState>(
    ROOM_BRAND_CAPTION_LOWER_THIRD_FEATURE_KEY
  );

export const brandCaptionLowerThird = createSelector(
  roomBrandCaptionLowerThirdState,
  (state: RoomBrandCaptionLowerThirdState) =>
    state.brandCaptionLowerThird
      ? buildBrandCaptionLowerThirdEntity(state.brandCaptionLowerThird)
      : null
);

export const isLoading = createSelector(
  roomBrandCaptionLowerThirdState,
  (state: RoomBrandCaptionLowerThirdState) => state.isLoading
);
